/**
 * Local Wikipedia-style lore article: Ra's Children (faction).
 * Placeholder until full article text is authored.
 */
import { createComingSoonArticle } from './createComingSoonArticle';

const rasChildrenArticle = createComingSoonArticle({
  title: "Ra's Children",
  image: '/factions/ra.png',
});

export default rasChildrenArticle;
